/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:40:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import { EPayMode } from '@root/constant';
import { IOrderCreateData, IRenewalOrderData } from '@root/types/order';
import { http } from '@shared';

export interface IGetPackagesProp {
  isSupportRenew?: string;
  excludeLevel?: string;
  planUnit?: string;
  level?: number;
  pageNum?: number;
  pageSize?: number;
  payMode?: EPayMode;
}

const getPackages = (data: IGetPackagesProp) => {
  return http.request({
    url: '/api/ipc/recordPlanController/getRecordGoodsList',
    params: {
      pageNum: 1,
      pageSize: 100,
      ...data,
    },
  });
};

// 创建订单
const createOrder = (data: IOrderCreateData) => {
  return http.request({
    url: '/payGateway/createOrder',
    method: 'POST',
    data,
  });
};

// 订单补充续订
const packageOrderRenewal = (data: IRenewalOrderData) => {
  return http.request({
    url: '/payGateway/renew',
    method: 'POST',
    data,
  });
};

// 获取订阅套餐详情
const getSubscribedInfo = (params: {
  payMode?: EPayMode;
  level?: number;
  houseId: string;
}) => {
  return http.request({
    url: '/api/ipc/recordPlanController/packageBuyInfoV2',
    params,
  });
};

// 获取订阅套餐详情
const getActivity = (code: string) => {
  return http.request({
    url: `/api/ipc/activity/${code}`,
  });
};

export {
  getPackages,
  createOrder,
  packageOrderRenewal,
  getSubscribedInfo,
  getActivity,
};
